import React from "react";
import Dashboard from "../features/dashboard/Dashboard";

const DashboardPage: React.FC = () => {
  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8">
       <Dashboard />
    </div>
  );
};

export default DashboardPage;